/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BigQueryIntegrationConfig } from '../models/BigQueryIntegrationConfig';
import { DataShareIntegrationConfig } from '../models/DataShareIntegrationConfig';
import { DatabricksIntegrationConfig } from '../models/DatabricksIntegrationConfig';
import { EmrIntegrationConfig } from '../models/EmrIntegrationConfig';
import { MicrosoftFabricIntegrationConfig } from '../models/MicrosoftFabricIntegrationConfig';
import { RedshiftIntegrationConfig } from '../models/RedshiftIntegrationConfig';
import { SnowflakeIntegrationConfig } from '../models/SnowflakeIntegrationConfig';

/**
* Integration-specific configuration container
*/
export class IntegConfig {
  'resourceSharing'?: DataShareIntegrationConfig;
  'redshift'?: RedshiftIntegrationConfig;
  'bigquery'?: BigQueryIntegrationConfig;
  'snowflake'?: SnowflakeIntegrationConfig;
  'databricks'?: DatabricksIntegrationConfig;
  'fabric'?: MicrosoftFabricIntegrationConfig;
  'emr'?: EmrIntegrationConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceSharing",
      "baseName": "resourceSharing",
      "type": "DataShareIntegrationConfig",
      "format": ""
    },
    {
      "name": "redshift",
      "baseName": "redshift",
      "type": "RedshiftIntegrationConfig",
      "format": ""
    },
    {
      "name": "bigquery",
      "baseName": "bigquery",
      "type": "BigQueryIntegrationConfig",
      "format": ""
    },
    {
      "name": "snowflake",
      "baseName": "snowflake",
      "type": "SnowflakeIntegrationConfig",
      "format": ""
    },
    {
      "name": "databricks",
      "baseName": "databricks",
      "type": "DatabricksIntegrationConfig",
      "format": ""
    },
    {
      "name": "fabric",
      "baseName": "fabric",
      "type": "MicrosoftFabricIntegrationConfig",
      "format": ""
    },
    {
      "name": "emr",
      "baseName": "emr",
      "type": "EmrIntegrationConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return IntegConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

